import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUpBlack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.41 7.41L6 2.83L10.59 7.41L12 6L6 0L0 6L1.41 7.41Z",
		fill: "black",
		fillOpacity: .54
	})]
});
const ForwardRef = forwardRef(SvgChevronUpBlack);
export { ForwardRef as ReactComponent };
